import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Hero.css";
import siteData from "../data/siteData.json";

export default function Hero() {
  const slides = siteData.heroSlides;

  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4500,
    arrows: true,
    dots: true,
    fade: true,
    pauseOnHover: false,
  };

  return (
    <section id="home" className="slider-area">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div className="slider-item" key={index}>
            <div
              className="slide-bg"
              style={{ backgroundImage: `url(${slide.img})` }}
            >
              <div className="overlay"></div>

              <div className="slide-content">
                <div className="slide-frame">
                  <h2>{slide.title}</h2>
                  <a className="hero-btn" href={slide.buttonLink}>
                    {slide.buttonText}
                  </a>
                </div>
              </div>

            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
